const doc = [({"da":({"js":({"admin":({"tenant_domains":({"select":({"choose_tenant_domain":"Vælg tenant domæne"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;